// deps
import React from "react";

// internal deps
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { getCloudinaryUrl } from "@swiggy-private/js-utils";
import { isEmpty } from "@swiggy-private/js-utils";

// styles
import styles from "../AddNewCard.v4.scss";

// test id
import { ADD_NEW_CARD_TEST_IDS } from "@swiggy-private/payment-test-ids";

type OfferBannerProps = {
    isOfferEnabled: string;
    imageId: string;
};

function OfferBanner(props: OfferBannerProps) {
    const { isOfferEnabled, imageId } = props;

    if (isOfferEnabled !== "true" || isEmpty(imageId)) {
        return null;
    }

    return (
        <div className={styles.offerBannerWrapper} data-testid={ADD_NEW_CARD_TEST_IDS.OFFER_BANNER}>
            <Image src={getCloudinaryUrl(imageId)} width="100%" />
        </div>
    );
}

export default React.memo(OfferBanner);
